import { render, staticRenderFns } from "./CompiledBidElementInfoBoxes.vue?vue&type=template&id=7e36afa8"
import script from "./CompiledBidElementInfoBoxes.vue?vue&type=script&lang=js"
export * from "./CompiledBidElementInfoBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports